import { render, staticRenderFns } from "./courseDiscount.vue?vue&type=template&id=2a87671c&scoped=true&"
import script from "./courseDiscount.vue?vue&type=script&lang=js&"
export * from "./courseDiscount.vue?vue&type=script&lang=js&"
import style0 from "./courseDiscount.vue?vue&type=style&index=0&id=2a87671c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87671c",
  null
  
)

export default component.exports